"use client";

import { RotateCcw, Volume2 } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import type { Vocabulary } from "@/types";

export function FlashcardDeck({ words }: { words: Vocabulary[] }) {
  const [index, setIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const word = words[index];

  if (!word) {
    return null;
  }

  const next = () => {
    setFlipped(false);
    setIndex((value) => (value + 1) % words.length);
  };

  const previous = () => {
    setFlipped(false);
    setIndex((value) => (value - 1 + words.length) % words.length);
  };

  return (
    <div>
      <div className="flashcard-3d h-72 w-full cursor-pointer" data-flipped={flipped} onClick={() => setFlipped((value) => !value)}>
        <div className="flashcard-inner relative h-full w-full">
          <div className="flashcard-face absolute inset-0 flex flex-col items-center justify-center rounded-2xl border border-cinnabar-100 bg-white p-6 text-center shadow-soft">
            <p className="text-7xl font-black text-cinnabar-700">{word.hanzi}</p>
            <p className="mt-4 text-sm font-semibold text-muted">Thẻ {index + 1}/{words.length}</p>
          </div>
          <div className="flashcard-face flashcard-back absolute inset-0 flex flex-col justify-center rounded-2xl border border-jade/30 bg-[#f4fffb] p-6 shadow-soft">
            <div className="flex items-center justify-between gap-3">
              <div>
                <p className="text-3xl font-black text-ink">{word.pinyin}</p>
                <p className="mt-1 text-lg font-bold text-cinnabar-700">{word.meaningVi}</p>
              </div>
              <Volume2 className="h-6 w-6 text-jade" />
            </div>
            {word.exampleZh ? <p className="mt-6 text-2xl font-bold text-ink">{word.exampleZh}</p> : null}
            {word.examplePinyin ? <p className="mt-2 text-sm text-muted">{word.examplePinyin}</p> : null}
            {word.exampleVi ? <p className="mt-2 text-sm font-semibold text-muted">{word.exampleVi}</p> : null}
          </div>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap items-center justify-center gap-3">
        <Button variant="outline" onClick={previous}>Trước</Button>
        <Button variant="ghost" onClick={() => setFlipped(false)}><RotateCcw className="h-4 w-4" /> Lật lại</Button>
        <Button onClick={next}>Tiếp theo</Button>
      </div>
    </div>
  );
}
